/* eslint-disable */
import { store } from '../../store'
// import { httpgst, http } from '../../main'
import { httpgst } from '../../main'
import router from '../../router'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  async downloadExcelReport({ commit }, { event }) {
    try {
      // event.context.loadingExcelReport = event.id
      const url = `api/expenses/to-xls/${event.id}`
      const options = {
        emulateJSON: false,
        headers: {
          'Content-Type': `application/xlsx`
        }
      }
      const params = {
        responseType: 'blob'
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token

      const response = await httpgst.get(url, params, options)
      const reportBinary = response.data
      event.context.forceFileDownload(reportBinary, `report-${event.id}.xlsx`)
    } catch (error) {
      console.log(error)
      event.context.showNotification(error.response, 'error')
    } finally {
      event.context.loadingExcelReport = false
    }
  },
  async getViatics({ commit, dispatch }, payload) {
    const url = `api/travel-expenses-request/by-user?user_id=${payload.event.id}&status=${payload.event.status}`
    const options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    try {
      const response = await httpgst.get(url, {}, options)
      commit('onGetViatics', { event: payload.event, response: response })
    } catch (error) {
      commit('onError', { event: payload.event, error: error })
    }
  },
  get({ commit, dispatch }, payload) {
    let url = 'api/expenses'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGet', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getFiltered({ commit, dispatch }, payload) {
    let url = payload.event.context.searchExpense === '' 
            ? `api/expenses/by-user/${store.state.userLogged.id}?status=${payload.event.context.statusExpense}&page=${payload.event.context.pagination.page}&perPage=${payload.event.context.pagination.rowsPerPage}`
            : `api/expenses/by-user/${store.state.userLogged.id}?status=${payload.event.context.statusExpense}&search=${payload.event.context.searchExpense}&page=${payload.event.context.pagination.page}&perPage=${payload.event.context.pagination.rowsPerPage}`

    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetFiltered', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getExpensesOpen({ commit, dispatch }, payload) {
    let url = 'api/expenses-open'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetExpensesOpen', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getExpensesOpenForUser({ commit, dispatch }, payload) {
    let url = 'api/expenses-open/for-user/' + payload.event.userId
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetExpensesOpen', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getById({ commit, dispatch }, payload) {
    let url = 'api/expenses/' + payload.event.expense_id
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetById', { event: payload.event, response: response })
      },
      error => {
        commit('onErrorById', { event: payload.event, error: error })
      }
    )
  },
  postReservation({ commit, dispatch }, payload) {
    let typeExpense = payload.event.item.has_advance

    const type = payload.event.context.tabActive === 1 ? 'REQUEST' : 'RESERVATION'
    
    let url = 'api/expenses'
    
    let params = {
      user_id: payload.event.item.user.id,
      start_date: payload.event.item.start_date,
      end_date: payload.event.item.end_date,
      description: payload.event.item.description,
      project_id: payload.event.item.project_id,
      status: 1,
      gst_expenses_status_id: 1,
      petty_cash_type: typeExpense === 'pettyCash' ? 1 : typeExpense === 'amexCard' ? 2 : 0,
      advance: 0,
      type: type,
      gst_travel_expenses_request_id: payload.event.item.viatic_request_id !== undefined ? payload.event.item.viatic_request_id : undefined
    }
    
    if (payload.event.item.has_advance === 'advance') {
      params.advance = payload.event.item.advance
    }

    if(((typeExpense === 'pettyCash' || typeExpense === 'amexCard') && payload.event.item.isVoucherAmount ) || typeExpense === 'okBlue'){
      params.voucher_amount = payload.event.item.voucher_amount
      params.is_blue_voucher  = true
    }

    if (payload.event.item.has_multiprojects) {
      params.project_list = payload.event.item.project_list
      params.has_multiprojects = payload.event.item.has_multiprojects
    }
    
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {}).then(
      response => {
        commit('onPost', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  post({ commit, dispatch }, payload) {
    let typeExpense = payload.event.item.has_advance
    
    let url = 'api/expenses'
    let params = {
      user_id: payload.event.user.id,
      start_date: payload.event.item.start_date,
      end_date: payload.event.item.end_date,
      description: payload.event.item.description,
      project_id: payload.event.item.project_id,
      status: 1,
      gst_expenses_status_id: 1,
      advance: 0,
      petty_cash_type: typeExpense === 'pettyCash' ? 1 : typeExpense === 'amexCard' ? 2 : 0,
      type: payload.event.item.type !== undefined ? payload.event.item.type : undefined,
      gst_travel_expenses_request_id: payload.event.item.viatic_request_id !== undefined ? payload.event.item.viatic_request_id : undefined
    }

    if (payload.event.item.has_advance === 'advance') {
      params.advance = payload.event.item.advance
    }

    if(((typeExpense === 'pettyCash' || typeExpense === 'amexCard') && payload.event.item.isVoucherAmount ) || typeExpense === 'okBlue'){
      params.voucher_amount = payload.event.item.voucher_amount
      params.is_blue_voucher  = true
    }
    
    if (payload.event.item.has_multiprojects) {
      params.project_list = payload.event.item.project_list
      params.has_multiprojects = payload.event.item.has_multiprojects
    }
    
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {}).then(
      response => {
        commit('onPost', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  put({ commit, dispatch }, payload) {
    let typeExpense = payload.event.item.has_advance
    let url = 'api/expenses/' + payload.event.item.id
    let params = {
      user_id: payload.event.item.user_id,
      start_date: payload.event.item.start_date,
      end_date: payload.event.item.end_date,
      description: payload.event.item.description,
      project_id: payload.event.item.project_id,
      status: payload.event.item.status,
      gst_expenses_status_id: payload.event.item.gst_expenses_status_id,
      type:
        payload.event.item.type !== undefined
          ? payload.event.item.type
          : undefined,
      gst_travel_expenses_request_id:
        payload.event.item.viatic_request_id !== undefined
          ? payload.event.item.viatic_request_id
          : undefined
    }

    if (payload.event.item.advance !== '') {
      params.advance = payload.event.item.advance
    }

    if(((typeExpense === 'pettyCash' || typeExpense === 'amexCard') && payload.event.item.isVoucherAmount ) || payload.event.context.type === 'okBlue'){
      params.is_blue_voucher  = true
      params.voucher_amount = payload.event.item.voucher_amount
      if(payload.event.context.type === 'okBlue') params.petty_cash_type = 0
    }

    params.project_list = payload.event.item.project_list || []
    params.has_multiprojects = payload.event.item.has_multiprojects

    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {}).then(
      response => {
        commit('onPut', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
    // }
  },
  delete({ commit, dispatch }, payload) {
    let url = 'api/expenses/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {}).then(
      response => {
        commit('onDelete', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  startWorkflow({ commit, dispatch }, payload) {
    let url = 'api/startWorkFlow/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, {}, {}).then(
      response => {
        commit('onStartWorkflow', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getCategories({ commit, dispatch }, payload) {
    let url = 'api/categories'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetCategories', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getHistory({ commit, dispatch }, payload) {
    let url = `api/expense-progress/${payload.event.id}`
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetHistory', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getExpensesValidators({ commit, dispatch }, payload) {
    let url = `api/expenses-validators/${payload.event.id}`
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetExpensesValidators', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getAcuse({ commit, dispatch }, payload) {
    let url = `api/report-acuse/${payload.event.id}`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetAcuse', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getWorkflowValidatorApprover({ commit, dispatch }, payload) {
    let url = `api/workflow-validator-approver/${payload.event.user_id}`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetWorkflowValidatorApprover', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  downloadRequest({ commit, dispatch }, payload) {
    let url =
      `api/travel-expenses-request/to-pdf/` + payload.event.expensesRequest
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/pdf'
      }
    }
    let params = {
      responseType: 'blob'
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, params, options).then(
      response => {
        commit('onDownloadRequest', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getExpensesStatusReturned({ commit, dispatch }, payload) {
    let url = 'api/expenses-status-returned'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetExpensesStatusReturned', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
}

// mutations
const mutations = {
  // Set the data obtained from the expenses endpoint
  onGet(state, payload) {
    payload.event.context.expenses = payload.response.data.data
  },
  onGetExpensesStatusReturned(state, payload) {
    payload.event.context.expensesReturned = payload.response.data.data
  },
  onGetViatics(state, payload) {
    payload.event.context.ifViatics = payload.response.data.data.length > 0
  },
  // Set the data obtained from the expenses endpoint and apply user_id filter
  onGetFiltered(state, payload) {
    let expenses = payload.response.data.data.data
    
    expenses.forEach(element => {
      element.amount = 0
      element.gst_expenses_items.forEach(elements => {
        element.amount = parseFloat(elements.total_mxn) + element.amount
      })
    })
    
    payload.event.context.expenses = expenses
    payload.event.context.loadingItems = false

    payload.event.context.pagination.rowsPerPage = parseInt(payload.response.data.data.per_page)
    payload.event.context.pagination.page = payload.response.data.data.current_page
    payload.event.context.pagination.totalItems = payload.response.data.data.total
    payload.event.context.pagination.lastPage = payload.response.data.data.last_page;
    // payload.event.context.expensesFilter()
  },
  onGetExpensesOpen(state, payload) {
    let expenses = payload.response.data.data
    expenses.forEach(element => {
      element.amount = 0
      element.gst_expenses_items.forEach(elements => {
        element.amount = parseFloat(elements.total_mxn) + element.amount
      })
    })
    payload.event.context.expensesOpen = expenses
    payload.event.context.loadingItems = false
    // payload.event.context.expensesFilter()
  },
  // Set the data obtained from the expenses endpoint when there is a matching id
  onGetById(state, payload) {
    payload.event.context.expense = payload.response.data.data
  },
  // Add the data from the new expense to the expenses list
  onPost(state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.loading = false
    payload.event.context.close()
    
    if(payload.event.context.openExpenseDialog){
      payload.event.context.addExpenseDialog = true
      return
    }
    
    payload.event.context.refresh()
  },
  // Updates the data displayed for the modified expense
  onPut(state, payload) {
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  // Removes the data of the deleted expense from the expenses list
  onDelete(state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeRemove()
    payload.event.context.refresh()
  },
  onStartWorkflow(state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeWorkflowDialog()
    payload.event.context.refresh()
  },
  // Set the data obtained from the categories endpoint
  onGetCategories(state, payload) {
    let categories = payload.response.data.data
    payload.event.context.categories = categories
  },
  onGetHistory(state, payload) {
    payload.event.context.histItem.progress = payload.response.data.data
    payload.event.context.filterHistory()
    payload.event.context.histLoading = false.data
  },
  onGetExpensesValidators(state, payload) {
    let expense = payload.response.data.data
    payload.event.context.representExpense = expense.user
    payload.event.context.validatorsExpenses = expense.workflow
  },
  onGetAcuse(state, payload) {
    if (payload.event.context.loadingAccuse)
      payload.event.context.loadingAccuse = false
    const byteCharacters = atob(payload.response.data.data.file)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    payload.event.context.forceFileDownload(
      byteArray,
      'Acuse' + `_${new Date().toISOString().substr(0, 10)}.pdf`
    )
  },
  // Shows a error message
  onError(state, payload) {
    if (payload.event.context.loadingAccuse)
      payload.event.context.loadingAccuse = false
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
  },
  onErrorById(state, payload) {
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    setTimeout(function() {
      router.push('/dashboard')
    }, payload.event.context.timeout)
  },
  onGetLogged(state, payload) {
    let userLogged = payload.response.data.data
    payload.event.context.userLogged = userLogged
  },
  onGetWorkflowValidatorApprover(state, payload) {
    let validators = []
    let approvers = []
    let counter = 0
    let approverByFlow = 0
    const responseValidatorsApprovers = Object.assign(
      {},
      payload.response.data.data
    )
    const listValidatorsApprovers = Object.getOwnPropertyNames(
      responseValidatorsApprovers
    )
    listValidatorsApprovers.forEach(i => {
      let el = responseValidatorsApprovers[i]
      el = { ...el }
      if (el.id) {
        counter++
        el.validatorId = counter
        validators.push(el)
        if(el.gst_approver_id > 0) approverByFlow = el.gst_approver_id
      } else {
        if(approverByFlow > 0) approvers.push(Object.values(el).find(obj => obj.id === approverByFlow))
        if(approvers.length === 0) approvers.push(Object.values(el).find(obj => obj.is_default === 1))
      }
    })

    const orderValidators = list => {
      let counter = 0
      let newList = []
      let first = list.find(x => x.is_first_step === 1)
      if (first !== undefined) {
        counter++
        first.validatorId = counter
        newList.push(first)
        let next = first.next_step
        list.forEach(i => {
          let newNext = list.find(x => x.id === next)
          if (newNext !== undefined) {
            counter++
            newNext.validatorId = counter
            newList.push(newNext)
            next = newNext.next_step
          }
        })
      }
      return newList
    }

    payload.event.context.validators = orderValidators(validators)
    payload.event.context.approvers = approvers
    payload.event.context.workflowName = payload.response.data.data[0].area.name
  },
  onDownloadRequest(state, payload) {
    payload.event.context.forceFileDownload(
      payload.response.data,
      'Request-' + payload.event.folio + '.pdf'
    )
    payload.event.context.loadingDownload = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/expenses.js